<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>

        <b-form @submit.stop.prevent="guardar">
            <b-container fluid>

                <b-row align-v="center">

                    <b-col cols="6">
                        <b-form-group align="left">
                            <label>Nombre del tipo de clínica
                                <validacion/>
                            </label>
                            <b-input-group size="sm" class="mb-2">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="menu-button-wide"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input
                                        id="idNombre"
                                        placeholder="Nombre del tipo de clinica"
                                        :state="validateState('descripcion')"
                                        v-model="$v.objGuardar.descripcion.$model"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <div class="formularios marginformularios"
                             style="display:flex;align-items:center">
                            <label class="bold marginlabel"
                                   style="margin-top:5px"
                            >Pertenece a turismo médico</label>
                            <b-form-checkbox
                                    id="activoWebComp"
                                    class="formularios marginformularios"
                                    v-model="$v.objGuardar.blnTurismoMedico.$model"
                                    :state="validateState('blnTurismoMedico')"
                                    value="true"
                                    unchecked-value="false"
                                    switch
                            ></b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col align="right">
                        <b-button
                                v-if="$localStorageService.can('BO_28_clini_alta_tipoClin')"
                                class="mt-3 botonesfooter"
                                variant="outline-primary"
                                style="width:10%;margin:10px"
                                block
                                type="submit">
                            Guardar
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>

    </div>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required, maxLength} from "vuelidate/lib/validators";

    export default {
        name: "altaTipoClinica",
        mixins: [validationMixin],
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                loading: false,
                objGuardar: {
                    descripcion: null,
                    blnTurismoMedico: false,
                }
            };
        },
        validations: {
            objGuardar: {
                descripcion: {required, maxLength: maxLength(50)},
                blnTurismoMedico: {},
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.$nextTick(() => {
                this.$v.$reset()
            });
        },
        methods: {
            validateState(name) {
                const {$dirty, $error} = this.$v.objGuardar[name];
                return $dirty ? !$error : null;
            },
            guardar() {
                this.$v.objGuardar.$touch();
                if (this.$v.objGuardar.$anyError) {
                    return;
                }
                this.loading = true;
                this.$http
                    .post(this.$api + "catalogos/crearTipoClinica", this.objGuardar)
                    .then((response) => {
                        if (response.data.data) {
                            this.$swal.fire({
                                position: "center",
                                icon: "success",
                                title: "El tipo de clinica se creó correctamente",
                                showConfirmButton: false,
                                timer: 3000,
                            });
                            this.$nextTick(() => {
                                this.$v.$reset()
                            });
                            this.objGuardar = {descripcion: '', blnTurismoMedico: false};
                        } else {
                            this.$swal.fire({
                                position: "center",
                                icon: "error",
                                title: "El tipo de clinica ya se encuentra registrado",
                                showConfirmButton: false,
                                timer: 3000,
                            });
                        }
                    }).catch((error) => {
                    this.$swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrio un error al registrar el nuevo tipo de clínica",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                });

            }
        }
    };
</script>